import React from "react";
import { TypeAnimation } from "react-type-animation";
import profile from "../assets/profile.jpg";
import linkedin from "../assets/icons/linkedin.svg";
import instagram from "../assets/icons/instagram.svg";
import github from "../assets/icons/github.svg";

function HomePage() {
  return (
    <div className="tokyo_tm_section">
      <div
        data-aos="fade-right"
        data-aos-duration="1200"
        className="aos-init aos-animate">
        <div className="tokyo_tm_home">
          <div className="home_content">
            <div className="avatar">
              <div
                className="image avatar_img"
                style={{
                  backgroundImage: "url(" + profile + ")",
                }}></div>
            </div>
            <div className="details">
              <div data-cursor-exclusion={true} data-cursor-size="80px">
                <h3 className="name">Natanael Yulius</h3>

                <h4 className="typer">
                  <span>
                    <TypeAnimation
                      sequence={[
                        "I am Web Developer",
                        1000,
                        "I am Android Developer",
                        1000,
                        "I am UI/UX Designer",
                        1000,
                      ]}
                      speed={10}
                      style={{ fontSize: "1em" }}
                      repeat={Infinity}
                    />
                  </span>
                </h4>
                <p className="job">
                  Android and Web Developer based in Tangerang, Banten and very
                  excited to learn something new!.
                </p>

                <ul className="social">
                  <li>
                    <a
                      href="https://www.instagram.com/natyulius"
                      target="_blank"
                      rel="noreferrer">
                      <img
                        className="svg"
                        src={instagram}
                        srcSet={instagram}
                        alt="social"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://github.com/yuliusius1"
                      target="_blank"
                      rel="noreferrer">
                      <img
                        className="svg"
                        src={github}
                        srcSet={github}
                        alt="social"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://linkedin.com/in/natyulius"
                      target="_blank"
                      rel="noreferrer">
                      <img
                        className="svg"
                        src={linkedin}
                        srcSet={linkedin}
                        alt="social"
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
